import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { StatementConfirmation, TxPinVerification } from "src/component"
import helpers from "src/utils/helpers"

export const StatementToEmbassy: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({
        sourceAccount: '', startDate: '', endDate: '', 
        applicantName: '', applicantCountry: '', recipientEmbassy: ''
    })
    const [view, setView] = useState('send-statement')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('statement-confirmation')
    }

    async function handleSubmit() {
        notifier.show('Statement Sent', null, 'success')
        close()
    }

    return (
        <>
            { view === 'send-statement' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Send Statement to Embassy</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Source Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Source Account"
                                        name='sourceAccount'
                                        value={input.sourceAccount}
                                        style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Source Account</option>
                                        <option value="2236728192">Qore - 2236728192</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Applicant's Name</label>
                                <input 
                                    placeholder="Enter Applicant's Name" 
                                    name='applicantName'
                                    value={input.applicantName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroupWithIcon>
                                <label>Applicant's Country</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='applicantCountry'
                                        value={input.applicantCountry}
                                        style={{color: input.applicantCountry ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Country</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Canada">Canada</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Start Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='startDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.startDate ? '#000000' : '#667085'}}
                                    value={input.startDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>End Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='endDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.endDate ? '#000000' : '#667085'}}
                                    value={input.endDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroupWithIcon>
                                <label>Recipient Embassy</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='recipientEmbassy'
                                        value={input.recipientEmbassy}
                                        style={{color: input.recipientEmbassy ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value=''>Select Embassy</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="France">France</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <AppSpan color="#0D968F">This service attracts a fee of N2,000</AppSpan>
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'statement-confirmation' &&
                <StatementConfirmation
                    close={close}
                    next={() => setView('pin')}
                    back={() => setView('send-statement')}
                    data={input}
                    type='Embassy'
                />
            }
        </>
    )
}